import * as API from '../api'
export const FETCH_SPECIALITY = 'FETCH_SPECIALITY'
export const FETCHING_SPECIALITY = 'FETCHING_SPECIALITY'
export const FETCH_SPECIALITY_ERROR = 'FETCH_SPECIALITY_ERROR'
export const FETCH_SPECIALITIES = 'FETCH_SPECIALITIES'
export const FETCHING_SPECIALITIES = 'FETCHING_SPECIALITIES'
export const FETCH_SPECIALITIES_ERROR = 'FETCH_SPECIALITIES_ERROR'
export const OPEN_MODAL = 'OPEN_MODAL'
export const CLOSE_MODAL = 'CLOSE_MODAL'
export const CHANGE_SPECIALITY = 'CHANGE_SPECIALITY'
export const DELETE_SPECIALITY = 'DELETE_SPECIALITY'
export const ADD_SPECIALITY = 'ADD_SPECIALITY'
export const EDIT_SPECIALITY = 'EDIT_SPECIALITY'
export const FORM_TOUCHED = 'FORM_TOUCHED'
export const NEW_FORM_SPECIALITY = 'NEW_FORM_SPECIALITY'
export const SPECIALITY_FORM_ERROR = 'SPECIALITY_FORM_ERROR'
export const CHANGE_PAGE = 'CHANGE_PAGE'
export const CHANGE_PER_PAGE = 'CHANGE_PER_PAGE'
export const CHANGE_ORDER_COLUMN = 'CHANGE_ORDER_COLUMN'
export const CHANGE_ORDER_DIRECTION = 'CHANGE_ORDER_DIRECTION'
export const RESET_STATE = 'RESET_STATE'

export const openModal = () => {
  return dispatch => {
    dispatch({ type: OPEN_MODAL })
  }
}

export const handleChangeSpeciality = speciality => {
  return dispatch => {
    dispatch({ type: CHANGE_SPECIALITY, speciality })
  }
}

const getDuplicateKeyField = errorMessage => {
  const [x, field = ''] = /collection: .* index: (.*)_/.exec(errorMessage) // eslint-disable-line
  return field
}

export const handleSpecialityError = (res, dispatch) => {
  const { data: errorMessage = '' } = res

  switch (true) {
    case errorMessage.includes('duplicate key error'):
      dispatch({
        type: FORM_TOUCHED
      })
      dispatch({
        type: SPECIALITY_FORM_ERROR,
        field: getDuplicateKeyField(errorMessage),
        message: `${getDuplicateKeyField(errorMessage)} já cadastrado.`
      })
      return Promise.reject(res)

    default:
      break
  }
}

export const newFormSpeciality = speciality => {
  return dispatch => {
    dispatch({ type: NEW_FORM_SPECIALITY })
  }
}

export const setSpecialityFormTouched = speciality => {
  return dispatch => {
    dispatch({ type: FORM_TOUCHED })
  }
}

export const closeModal = () => {
  return dispatch => {
    dispatch({ type: CLOSE_MODAL })
  }
}

export const restoreSpeciality = id => {
  return dispatch => {
    dispatch({ type: FETCHING_SPECIALITIES })
    return API.specialities
      .restoreSpeciality(id)
      .then(({ data }) => {
        dispatch({ type: EDIT_SPECIALITY, speciality: data })
      })
      .catch(err => {
        const { response = {} } = err
        const { data = {} } = response
        const { message } = data
        dispatch({
          type: FETCH_SPECIALITIES_ERROR,
          err: message || 'Serviço indisponível'
        })
        handleSpecialityError(response, dispatch)
        return Promise.reject(response)
      })
  }
}

export const handleChangePage = page => {
  return dispatch => {
    dispatch({ type: CHANGE_PAGE, page })
  }
}

export const handleChangePerPage = perPage => {
  return dispatch => {
    dispatch({ type: CHANGE_PER_PAGE, perPage })
  }
}

export const changeOrderColumn = column => {
  return dispatch => {
    dispatch({ type: CHANGE_ORDER_COLUMN, column })
  }
}

export const changeOrderDirection = direction => {
  return dispatch => {
    dispatch({ type: CHANGE_ORDER_DIRECTION, direction })
  }
}

export const resetState = () => {
  return dispatch => {
    dispatch({ type: RESET_STATE })
  }
}

export const fetchSpecialities = options => {
  return dispatch => {
    dispatch({ type: FETCHING_SPECIALITIES })
    return API.specialities
      .getSpecialities(options)
      .then((res = {}) => {
        const { data } = res
        dispatch({
          type: FETCH_SPECIALITIES,
          specialities: data.items,
          length: data.length,
          page: data.page,
          order: data.order,
          rowsPerPage: data.rowsPerPage
        })
      })
      .catch(err => {
        const { response = {} } = err
        const { data = {} } = response
        const { message } = data
        dispatch({
          type: FETCH_SPECIALITIES_ERROR,
          err: message || 'Serviço indisponível'
        })
        return Promise.reject(err)
      })
  }
}

export const deleteSpeciality = id => {
  return dispatch => {
    dispatch({ type: FETCHING_SPECIALITIES })
    return API.specialities
      .deleteSpeciality(id)
      .then(({ data: speciality }) => {
        dispatch({ type: DELETE_SPECIALITY, speciality })
      })
      .catch(err => {
        const { response = {} } = err
        const { data = {} } = response
        const { message } = data
        dispatch({
          type: FETCH_SPECIALITIES_ERROR,
          err: message || 'Serviço indisponível'
        })
        return Promise.reject(err)
      })
  }
}

export const addSpeciality = speciality => {
  return dispatch => {
    dispatch({ type: FETCHING_SPECIALITIES })
    dispatch({ type: FETCHING_SPECIALITY })
    return API.specialities
      .addSpeciality(speciality)
      .then(({ data }) => {
        dispatch({ type: ADD_SPECIALITY, speciality: data })
      })
      .catch(err => {
        const { response = {} } = err
        const { data = {} } = response
        const { message } = data
        handleSpecialityError(response, dispatch)
        dispatch({
          type: FETCH_SPECIALITIES_ERROR,
          err: message || 'Serviço indisponível'
        })
        return Promise.reject(err)
      })
  }
}

export const editSpeciality = speciality => {
  return dispatch => {
    dispatch({ type: FETCHING_SPECIALITIES })
    dispatch({ type: FETCHING_SPECIALITY })
    return API.specialities
      .editSpeciality(speciality)
      .then(({ data }) => {
        dispatch({ type: EDIT_SPECIALITY, speciality: data })
      })
      .catch(err => {
        const { response = {} } = err
        const { data = {} } = response
        const { message } = data
        dispatch({
          type: FETCH_SPECIALITIES_ERROR,
          err: message || 'Serviço indisponível'
        })
        handleSpecialityError(response, dispatch)
        return Promise.reject(response)
      })
  }
}

export const fetchSpeciality = id => {
  return dispatch => {
    dispatch({ type: FETCHING_SPECIALITY, clear: true })
    dispatch({ type: OPEN_MODAL })
    return API.specialities
      .getSpeciality(id)
      .then(({ data }) => {
        dispatch({ type: FETCH_SPECIALITY, speciality: data })
      })
      .catch(err => {
        const { response = {} } = err
        const { data = {} } = response
        const { message } = data
        dispatch({
          type: FETCH_SPECIALITY_ERROR,
          err: message || 'Serviço indisponível'
        })
        return Promise.reject(err)
      })
  }
}



// WEBPACK FOOTER //
// ./src/actions/specialities.js